import { CompetitorResult } from './result';

export enum WorkoutType {
  AMRAP = 'AMRAP',
  FOR_TIME = 'FOR_TIME',
  EMOM = 'EMOM',
  MAX_TIME = 'MAX_TIME',
  MAX_WEIGHT = 'MAX_WEIGHT',
}

export enum CompetitionCategory {
  RX = 'RX',
  SCALED = 'SCALED',
}

export interface Workout {
  id: string;
  name: string;
  description: string;
  type: WorkoutType;
  items: string[];
  timeCap: number;
  category: CompetitionCategory;
  results: CompetitorResult[];
}

export interface CreateWorkoutInput {
  name: string;
  description: string;
  type: WorkoutType;
  items: string[];
  timeCap: number;
  category: CompetitionCategory;
}
